var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetAllocationKsBalanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0C48.0782 1.20182e-07 57.7437 4.00356 64.8701 11.1299C71.9964 18.2563 76 27.9218 76 38C76 48.0782 71.9964 57.7437 64.8701 64.8701C57.7437 71.9964 48.0782 76 38 76V62.7C44.5508 62.7 50.8334 60.0977 55.4655 55.4655C60.0977 50.8334 62.7 44.5508 62.7 38C62.7 31.4492 60.0977 25.1666 55.4655 20.5345C50.8334 15.9023 44.5508 13.3 38 13.3V0Z",
    fill: "#64D68B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 76C27.9218 76 18.2563 71.9964 11.1299 64.8701C4.00356 57.7437 -2.80357e-07 48.0782 0 38C2.80357e-07 27.9218 4.00356 18.2563 11.1299 11.1299C18.2563 4.00356 27.9218 -1.20182e-07 38 0V13.3C31.4492 13.3 25.1666 15.9023 20.5345 20.5345C15.9023 25.1666 13.3 31.4492 13.3 38C13.3 44.5508 15.9023 50.8334 20.5345 55.4655C25.1666 60.0977 31.4492 62.7 38 62.7V76Z",
    fill: "#21C559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 34.0001H43V32.2101C43 29.6001 41.09 27.2701 38.49 27.0201C35.51 26.7401 33 29.0801 33 32.0001V34.0001H30L30 48.0001H46V34.0001ZM38 43.0001C36.9 43.0001 36 42.1001 36 41.0001C36 39.9001 36.9 39.0001 38 39.0001C39.1 39.0001 40 39.9001 40 41.0001C40 42.1001 39.1 43.0001 38 43.0001ZM35 34.0001V32.0001C35 30.3401 36.34 29.0001 38 29.0001C39.66 29.0001 41 30.3401 41 32.0001V34.0001H35Z",
    fill: "#21C559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAllocationKsBalanced);
export default __webpack_public_path__ + "static/media/asset-allocation-ks-balanced.2ade280ed745e125a5f6b4f838465d7e.svg";
export { ForwardRef as ReactComponent };